import qs from "qs";
import axios from "axios";
import Jsona from "jsona";

const url = process.env.VUE_APP_API_BASE_URL;
const jsona = new Jsona();

function list(params) {
  const options = {
    params: params,
    paramsSerializer: function (params) {
      return qs.stringify(params, {encode: false});
    }
  };

  return axios.get(`${url}/engineers`, options)
    .then(response => {
      return {
        list: response.data.result,
        meta: response.data.meta,
        page: response.data.page
      };
    });
}

function get(id, params) {
  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    },
    params: params,
    paramsSerializer: function (params) {
      return qs.stringify(params, {encode: false});
    }
  };

  return axios.get(`${url}/engineers/view/${id}`, options)
    .then(response => {
      return response.data.engineer;
    });
}


function contact(id, params) {
    const options = {
      headers: {
        'Accept': 'application/vnd.api+json',
        'Content-Type': 'application/vnd.api+json',
      },
      params: params,
      paramsSerializer: function (params) {
        return qs.stringify(params, {encode: false});
      }
    };
  
    return axios.post(`${url}/engineers/contact/${id}`, options)
      .then(response => {
        return response.data;
      });
  }


export default {
  list,
  get,
  contact
};

